import React, { useEffect } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const DarkModeToggle: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useAuth();

  // Apply or remove dark mode immediately
  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkMode);
  }, [isDarkMode]);

  const handleToggle = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("dark_mode", newMode ? "true" : "false");
    // The useEffect above applies it instantly
  };

  return (
    <button
      onClick={handleToggle}
      className="p-2 rounded-full hover:bg-yellow-200 dark:hover:bg-gray-700 transition-colors flex items-center justify-center"
      title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
    >
      {isDarkMode ? (
        <FaSun className="text-yellow-400 w-5 h-5 transition-transform duration-300" />
      ) : (
        <FaMoon className="text-blue-500 dark:text-gray-300 w-5 h-5 transition-transform duration-300" />
      )}
    </button>
  );
};

export default DarkModeToggle;


export function ThemeSwitch() {
    const { isDarkMode, setIsDarkMode } = useAuth();

  // Apply or remove dark mode immediately
  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDarkMode);
  }, [isDarkMode]);

  const handleToggle = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("dark_mode", newMode ? "true" : "false");
    // The useEffect above applies it instantly
  };
  
  return (
    <button
      onClick={handleToggle}
      className={`relative w-16 h-8 rounded-full transition-colors duration-300 focus:outline-none ${
        isDarkMode ? "bg-gray-700" : "bg-yellow-400"
      }`}
      title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
    >
      {/* Toggle circle */}
      <span
        className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          isDarkMode ? "translate-x-8" : "translate-x-0"
        } flex items-center justify-center`}
      >
        {isDarkMode ? (
          <FaMoon className="text-gray-700 w-4 h-4" />
        ) : (
          <FaSun className="text-gray-400 w-4 h-4" />
        )}
      </span>
    </button>
  );
}